export default {
    appname: 'Financial Management',
    login: 'Login',
    go_wallet_to_do:"Please operate in the wallet client!",
    investment_is_too_small:"The investment amount is lower than the minimum investment amount !",
    no_balance:"The balance is not enough, please recharge first!",
    walletConnected:"Connect wallet",
    openWallet: "Please open the wallet client",
    app:{
        product:"product",
        order:"order",
        my:"my",
    },
    productDetail:{
        arp:"ARP",
        minimum:"Minimum",
        holdingPeriod:"Holding period",
        day:"Day",
        basic_interest:"Basic interest",
        team_interest:"Team interest",
        total_interest:"Total interest",
        expected_returns:"Expected returns",
        principal:"Principal",
        purchase_confirmation:"Purchase confirmation",
        condescribe1:"Are you sure buy",
        condescribe2:"product",
        condescribe3:"locking",
        condescribe4:"days",
        condescribe5:"arp",
        condescribe6:"expected returns",
        condescribe7:"",
    },
    orderPage:{
        noOrders:"No orders yet",
        lockedPos:"Locked position interest",
        waitRed:"Waiting for redemption",
        redComple:"Redemption completed",
        unexpected:"Unexpected termination",
        arp:"ARP",
        end_time:"Expiration",

    },
    orderDetail:{
        purchTime:"Purchase time",
        basic_interest:"Basic interest",
        team_interest:"Team interest",
        total_profile:"Total profit",
        total_interest:"Total interest",
        buy_amount:"Investment amount",
        end_time:"Expiration time",
        time:"time",
    },
    my:{
        availableFunds:"Available Funds",
        team_interest:"Team interest",
        withdrawals:"Withdrawals",
        charge:"Recharge",
        bill:"Bill",
        team:"Team",
        announcement:"Announcement",
    },
    withdraw:{
        minimumWithdrawal:"Minimum withdrawal",
        fees:"Fees",
        every:"time",
        availableBalance:"Available balance",
        withdrawalAmount:"Withdrawal amount",
        time:"time",
        date:"date",
        amount:"Amount",
        state:"State",
        finish:"Finish",
        pendding:"Pendding",
        fail:"Fail",
        minwithdrawal:"Wrong withdrawal amount, minimum withdrawal ",

    },
    depositPage:{
        mincharge:"Minimum deposit",
        chargeamount:"Recharge amount",
        rechargeDes:"The platform recharge address is a public payment account. Please recharge through your wallet and do not recharge through the exchange withdrawal method.",
        rechargeDes2:"Please keep your private key safe. Disclosing your private key means you will lose control of your platform assets.",
        charge:"Recharge",
        time:"time",
        date:"date",
        amount:"Amount",
        state:"State",
        rechargeOk:"Recharge successful, waiting for the account to arrive!",
        rechargeFail:"Recharge failed",
        someError:"some error",
        rechargeAmountError:"Wrong amount of recharge",
        minRecharge:"Minimum deposit 10 USDT",
        balanceNo:"Insufficient balance",
        finish:"Finish",
        pendding:"Pendding",
        fail:"Fail",

    },
    historyPage:{
        noHistory:"No history page",
        finish:"Finish",
        pendding:"Pendding",
        fail:"Fail",
        buy:"Buy",
        sell:"Sell",
        recharge:"Recharge",
        withdrawal:"Withdrawal",
        award:"Award",
        other:"Other",
        fee:"Fee",
    },
    teamPage:{
        desc:"When your friends log in to the platform through your invitation link to participate in the investment, both parties will receive a 10USDT invitation reward. After inviting a specified number of valid users, you will receive a specified team interest, which will take effect immediately.",
        invitValid:"Valid number of invitations",
        team_interest:"Team interest",
        copy_url:"Copy invitation link",
        sleep:"Sleep",
        activation:"Activation",
        copyOk:"Invite link copied to clipboard！",
        copyFail:"Failed to copy the invitation link, please copy it manually：",
    },
    postPage:{
        email:"Contact us by email",
        tg:"Telegram Contact Us"
    },
    postDetail:{
        sincerely:"Sincerely",
        tg:"Telegram official customer service"
    },
    homePage:{
        arp:"ARP",
        minimum:"Minimum",
        holdingPeriod:"Holding",
        day:"Day",
        heroKicker:"USDT · On-chain yield",
        heroTitle:"Private wealth, compounding.",
        heroSub:"Decentralized USDT yield products for serious capital. Lock, earn, and track every position in one place.",
        trust1:"Wallet signed",
        trust2:"USDT settled",
        trust3:"Locked yield",
        products:"Featured products",
        investNow:"Invest now",
        empty:"No products yet",
    },
    seo:{
        home:{
            title:"CoinUp | USDT On-chain Yield & Locked Savings",
            description:"Decentralized USDT yield. Wallet-signed, locked-term interest, on-chain settlement. Products from 1,000 USDT."
        },
        product:{
            title:"Yield products | CoinUp",
            description:"Compare USDT lock-up products by APY, minimum amount and term. Connect a wallet to invest.",
            dynamicTitle:"{name} {arp}% APY | CoinUp",
            dynamicDesc:"{name}: {arp}% APY, from {min} USDT, {days}-day lock. Subscribe on CoinUp."
        },
        post:{
            title:"Announcements | CoinUp",
            description:"Official CoinUp notices, product rules and support contacts."
        },
        postDetail:{
            title:"Announcement | CoinUp",
            description:"CoinUp platform announcement."
        },
        my:{ title:"Account | CoinUp", description:"Connect a wallet to view available funds and team yield." },
        team:{ title:"Team | CoinUp", description:"Invite friends to invest and unlock team interest." },
        withdraw:{ title:"Withdraw | CoinUp", description:"Withdraw available USDT to your wallet." },
        deposit:{ title:"Deposit | CoinUp", description:"Deposit USDT from your wallet." },
        order:{ title:"Orders | CoinUp", description:"View lock-up orders and redemption status." },
        orderDetail:{ title:"Order detail | CoinUp", description:"Interest and maturity for a single investment." },
        history:{ title:"Bills | CoinUp", description:"Deposit, withdrawal and investment history." }
    },
    faq:{
        title:"FAQ",
        q1:"What is CoinUp?",
        a1:"CoinUp is an on-chain USDT lock-up yield platform. After connecting a wallet and signing, you lock principal for a product term and earn stated APY.",
        q2:"How do I start investing?",
        a2:"Open coinupusa.com, connect and log in with your wallet, pick a product, enter principal, then sign in the wallet. Deposit USDT first if the balance is too low.",
        q3:"How is yield calculated?",
        a3:"Estimated return ≈ principal × (base APY + team APY) / 365 × lock days. Team APY depends on qualified invites.",
        q4:"Which networks are supported?",
        a4:"USDT deposits and settlement via wallet on Ethereum and BNB Chain. Do not withdraw from an exchange directly to the platform address."
    },
    button: {
        buy: 'Buy',
        confirmation: 'Confirmation',
        cancel: 'Cancel',
        charge: 'Recharge',
        redemption: 'Redemption',
        withdrawal:"Withdrawal",
    }
};